import { SCREENS, REDUX_ACTIONS, GAME_ID } from 'a/doubleTrouble/data/constants';
import { persistStateTypes } from 'a/reducers/persistStateReducer';

const initState = { currentScreen: SCREENS.PROGRESS };

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload };

    case REDUX_ACTIONS.START_ROUND:
      return { currentScreen: SCREENS.STANDARD };

    // Return to Progress Screen when gamestate call has been resolved
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return { currentScreen: SCREENS.PROGRESS };

    // Show Loading screen when gamestate request goes out
    case persistStateTypes.REQUEST_GAMESTATE:
      return { currentScreen: SCREENS.LOADING };

    default:
      return state;
  }
};

export default screenReducer;
